import React from 'react';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { useRouter } from 'hooks/use-router';
import { ERoutesPrivate, ERoutesType, routes } from 'types/routes';
import GroupIcon from '@material-ui/icons/Group';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import PolicyIcon from '@material-ui/icons/Policy';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import SecurityIcon from '@material-ui/icons/Security';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined';

import {
    SidebarNav,
    NavSectionWrapper,
    SidebarStyled,
    NavSectionTitle,
    NavItem,
} from './index.styled';
import useCurrentSessionData from 'hooks/use-current-session-data';

const Sidebar = () => {
    const { pathname, history } = useRouter();
    const { permissions } = useCurrentSessionData();

    return (
        <SidebarStyled>
            <SidebarNav>
                <NavSectionWrapper>
                    <NavSectionTitle>Navigation</NavSectionTitle>
                    <NavItem
                        isActive={routes[ERoutesType.Private][
                            ERoutesPrivate.Dashboard
                        ].includes(pathname)}
                        onClick={() =>
                            history.push(
                                routes[ERoutesType.Private][
                                    ERoutesPrivate.Dashboard
                                ][0],
                            )
                        }
                    >
                        <DashboardIcon /> Dashboard
                    </NavItem>
                    {permissions.pendingTaskView && (
                        <NavItem
                            isActive={routes[ERoutesType.Private][
                                ERoutesPrivate.PendingTasks
                            ].includes(pathname)}
                            onClick={() =>
                                history.push(
                                    routes[ERoutesType.Private][
                                        ERoutesPrivate.PendingTasks
                                    ][0],
                                )
                            }
                        >
                            <AssignmentIcon /> Pending Tasks
                        </NavItem>
                    )}
                    {permissions.userView && (
                        <NavItem
                            isActive={routes[ERoutesType.Private][
                                ERoutesPrivate.Users
                            ].includes(pathname)}
                            onClick={() =>
                                history.push(
                                    routes[ERoutesType.Private][
                                        ERoutesPrivate.Users
                                    ][0],
                                )
                            }
                        >
                            <GroupIcon /> Users
                        </NavItem>
                    )}
                    {permissions.adminsView && (
                        <NavItem
                            isActive={routes[ERoutesType.Private][
                                ERoutesPrivate.Admins
                            ].includes(pathname)}
                            onClick={() =>
                                history.push(
                                    routes[ERoutesType.Private][
                                        ERoutesPrivate.Admins
                                    ][0],
                                )
                            }
                        >
                            <SupervisedUserCircleIcon /> Admins
                        </NavItem>
                    )}
                    {permissions.transactionView && (
                        <NavItem
                            isActive={routes[ERoutesType.Private][
                                ERoutesPrivate.Transactions
                            ].includes(pathname)}
                            onClick={() =>
                                history.push(
                                    routes[ERoutesType.Private][
                                        ERoutesPrivate.Transactions
                                    ][0],
                                )
                            }
                        >
                            <AccountBalanceWalletIcon /> Transactions
                        </NavItem>
                    )}
                    {permissions.withdrawalView && (
                        <NavItem
                            isActive={routes[ERoutesType.Private][
                                ERoutesPrivate.Withdraws
                            ].includes(pathname)}
                            onClick={() =>
                                history.push(
                                    routes[ERoutesType.Private][
                                        ERoutesPrivate.Withdraws
                                    ][0],
                                )
                            }
                        >
                            <MoneyOffIcon /> Withdrawals
                        </NavItem>
                    )}
                    {permissions.screeningView && (
                        <NavItem
                            isActive={routes[ERoutesType.Private][
                                ERoutesPrivate.Screenings
                            ].includes(pathname)}
                            onClick={() =>
                                history.push(
                                    routes[ERoutesType.Private][
                                        ERoutesPrivate.Screenings
                                    ][0],
                                )
                            }
                        >
                            <PolicyIcon /> Screenings
                        </NavItem>
                    )}
                    {permissions.adminActivityLogView && (
                        <NavItem
                            isActive={routes[ERoutesType.Private][
                                ERoutesPrivate.AdminActivityLog
                            ].includes(pathname)}
                            onClick={() =>
                                history.push(
                                    routes[ERoutesType.Private][
                                        ERoutesPrivate.AdminActivityLog
                                    ][0],
                                )
                            }
                        >
                            <ListAltOutlinedIcon /> Admin Activity Logs
                        </NavItem>
                    )}
                    {permissions.userActivityLogView && (
                        <NavItem
                            isActive={routes[ERoutesType.Private][
                                ERoutesPrivate.UserActivityLog
                            ].includes(pathname)}
                            onClick={() =>
                                history.push(
                                    routes[ERoutesType.Private][
                                        ERoutesPrivate.UserActivityLog
                                    ][0],
                                )
                            }
                        >
                            <ListAltOutlinedIcon /> User Activity Logs
                        </NavItem>
                    )}
                    <NavItem
                        isActive={routes[ERoutesType.Private][
                            ERoutesPrivate.TwoFA
                        ].includes(pathname)}
                        onClick={() =>
                            history.push(
                                routes[ERoutesType.Private][
                                    ERoutesPrivate.TwoFA
                                ][0],
                            )
                        }
                    >
                        <SecurityIcon /> 2FA
                    </NavItem>
                </NavSectionWrapper>
            </SidebarNav>
        </SidebarStyled>
    );
};

export default Sidebar;
